/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.no.auth.rpc.PublicSearchService
 */

export const searchRpc = {
  serviceName: 'com.hubspot.learning.center.search.no.auth.rpc.PublicSearchService',
  rpcName: 'search',
  auth: 'external',
  fingerprint: 'nNyD99hcDXAZCG1eq9XNkxLuLWvMCU-G',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};